import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'

import { Box } from '@mui/material'
import { SidebarIds } from '@/constants/sidebar'
import { ApplicationState } from '@/state/root.models'

import logoLunaris from '@/assets/img/logo-lunaris.png'
import logoSm from '@/assets/img/logo-lunaris-moon.png'
import MenuComponent from './components/menu/index.component'

import useSidebarActions from './hooks/use-sidebar-actions.hook'
import useSidebarUI from './hooks/use-sidebar-ui.hook'
import UiFeedbackComponent from './components/ui-feedback/index.component'

import useStyles from './style'
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'

const SidebarComponent = () => {
  const { classes } = useStyles()

  const { userSession } = useSelector(({ auth }: ApplicationState) => auth)

  const { setSidebarIds } = useSidebarActions()

  const { ref, sidebarStatus, handleSidebarClose, handleSidebarOpen } =
    useSidebarUI()

  useEffect(() => {
    setSidebarIds(SidebarIds[userSession?.role].ids)
  }, [userSession]) // eslint-disable-line

  return (
    <Box className={`${classes.sidebar} ${sidebarStatus ? 'open' : 'close'}`}>
      <Box
        className="openArrow"
        onClick={() => {
          sidebarStatus ? handleSidebarClose() : handleSidebarOpen()
        }}
      >
        {sidebarStatus ? <ArrowBackIos /> : <ArrowForwardIos />}
      </Box>
      <Box
        className={clsx(classes.sidebarFixed, {
          [classes.sidebarOpen]: sidebarStatus,
          [classes.sidebarClosed]: !sidebarStatus,
        })}
      >
        <Box
          display="flex"
          flexWrap="nowrap"
          alignItems="center"
          pr="7px"
          pl="7px"
        >
          <Box
            margin="0px auto"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              sidebarStatus ? handleSidebarClose() : handleSidebarOpen()
            }}
          >
            {sidebarStatus ? (
              <img
                src={logoLunaris}
                alt="Logo Lunaris"
                style={{ width: '200px' }}
              />
            ) : (
              <img
                src={logoSm}
                alt="Logo Lunaris"
                style={{ width: '36px', height: '36px' }}
              />
            )}
          </Box>
        </Box>

        <Box height="100%" overflow="hidden" mb={3} p={2} ref={ref}>
          <MenuComponent
            sidebarStatus={sidebarStatus}
            handleSidebarOpen={handleSidebarOpen}
          />
        </Box>
      </Box>
      <UiFeedbackComponent />
    </Box>
  )
}

export default SidebarComponent
